import _createClass from "@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { onlyAggregatePropType } from '../../../common/propTypes';
import { AfsTableWrapper } from '../shared/AfsTableWrapper/presenter';
import { AfsPartsContainer } from '../shared/AfsPartsContainer/presenter';
import AggregationTable from '../shared/AggregationTable';
export var AggregationType = /*#__PURE__*/function (_Component) {
  function AggregationType() {
    var _this2;
    _classCallCheck(this, AggregationType);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this2 = _callSuper(this, AggregationType, [].concat(args));
    _defineProperty(_this2, "render", function () {
      var _this2$props = _this2.props,
        answerSummary = _this2$props.answerSummary,
        itemId = _this2$props.itemId;
      return /*#__PURE__*/React.createElement(AfsTableWrapper, null, /*#__PURE__*/React.createElement(AfsPartsContainer, {
        aggregationTable: /*#__PURE__*/React.createElement(AggregationTable, {
          itemId: itemId,
          answerSummary: answerSummary
        })
      }));
    });
    return _this2;
  }
  _inherits(AggregationType, _Component);
  return _createClass(AggregationType);
}(Component);
_defineProperty(AggregationType, "propTypes", {
  itemId: PropTypes.number.isRequired,
  answerSummary: onlyAggregatePropType
}.isRequired);